const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

function floor(value: number, precision = 2): number {
  const base = 10 ** precision;
  const m = Number((Math.abs(value) * base).toPrecision(15));

  return (Math.floor(m) / base) * Math.sign(value);
}

function round(value: number, precision = 2): number {
  const base = 10 ** precision;
  const m = Number((Math.abs(value) * base).toPrecision(15));

  return (Math.round(m) / base) * Math.sign(value);
}

function toCurrency(amount: number | string): string {
  const number = typeof amount === 'string'
    ? Number.parseFloat(amount)
    : amount;

  return formatter.format(number);
}

export { round, floor, toCurrency };
